import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=aa71a3b4&scoped=true&"
import script from "./v-select.vue?vue&type=script&lang=js&"
export * from "./v-select.vue?vue&type=script&lang=js&"
import style0 from "./v-select.vue?vue&type=style&index=0&id=aa71a3b4&lang=scss&scoped=true&"
import style1 from "./v-select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa71a3b4",
  null
  
)

export default component.exports